import React, { Component } from 'react';
import { connect } from 'react-redux'
import { logOut } from '../Actions/Login'
import { Link } from 'react-router-dom'

import AppStack from './AppStack'

class Home extends Component {

	constructor(props){

       super(props);

    }

	render(){

		return (

			<AppStack className="home">

				<section className="wysiwyg">

				<div className="container">

					<div className="page-title-container"><div className="page-title"><h1>Senior Software Engineer</h1></div></div>

					<div className="body">

						<div className="image">

							<img src="/assets/me.jpg"/>

						</div>

					</div>
				</div>

				</section>

			</AppStack>
		);

	}

}



const mapStateToProps = (state) => {
	return { user: state.User };
}
const mapDispatchToProps = (dispatch) => {
	return {
		onLogout:() => { dispatch(logOut())}
	}
}

export default connect(mapStateToProps,mapDispatchToProps)(Home)



// WEBPACK FOOTER //
// ./src/Components/Home.js